import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import IconButton from '@mui/material/IconButton';
import PersonIcon from '@mui/icons-material/Person';
import Tooltip from '@mui/material/Tooltip';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { getPublicProfileUrl } from '../../helpers/providers';

const ViewProviderButton = props => {
  const {iconOnly, textOnly} = props;
  const navigate = useNavigate();
  const providerId = (
    isString(props.providerId) || isNumber(props.providerId)
    ? props.providerId
    : get(props, 'provider.id')
  ) || '';
  const url = getPublicProfileUrl(props.provider);
  const onClick = () => navigate(url);
  const childProps = {
    onClick,
    disabled: !providerId,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly || textOnly ? null : <PersonIcon/>,
    fullWidth: props.fullWidth || null,
    size: props.size
  };
  return (
    iconOnly
    ? <Tooltip title='Provider Details'>
      <IconButton {...childProps}>
        <PersonIcon/>
      </IconButton>
    </Tooltip>
    : <Button {...childProps}>
        <Typography variant={props.variantText} noWrap className={props.classButtonText || ''}>
          Provider Details
        </Typography>
    </Button>
  );
};

ViewProviderButton.defaultProps = {
  iconOnly: false,
  textOnly: false,
};

ViewProviderButton.propTypes = {
  provider: PropTypes.object,
  providerId: PropTypes.string, // either this or the provider
  iconOnly: PropTypes.bool,
};

export default ViewProviderButton;
